export default __webpack_public_path__ + "static/media/landing-dog.5e89f360.webp";